import React, { useState } from "react";

import Login from "../../Components/Login/Login";

import User_list from "../Users/User_list";
import All_User_list from "../AllUsers/All_User_list";

import PostList from "../Post/NewsList";
import AddPosts from "../Post/AddNews";
import Indust from "../Users/IndustrialUnit";
import Province from "../Province/Province_list";
import Ads from "../Ads/Ads_list";
import AdsCat from "../AdsCategory/Category";
import Setting from "../Setting/setting";

import "bootstrap/dist/css/bootstrap.css";
import "./menu.css";
import Raeenlogo from "../../img/maloos-logo.png";
import { Icon, Mylogo } from "../Useful/Useful";
import { HashRouter as Router, Switch, Route, Link } from "react-router-dom";
import settingIcon from "../../img/setting.png";
import EditUser from "../Users/EditUser";
import Forgetpass from "../Login/Forgetpass";
import PassRecover from "../Login/PassRecovery";
import { useHistory } from "react-router-dom";

import {
  FcNews,
  FcManager,
  FcFlowChart,
  FcFullTrash,
  FcPaid,
  FcApproval,
  FcTodoList,
  FcFeedback,
  FcSms,
  FcSupport,
  FcBusinessman,
  FcGlobe,
  FcFactory,
  FcDecision,
  FcSettings,
  FcList,
} from "react-icons/fc";

export default function BasicExample() {
  const history = useHistory();
  const [resource, setResource] = useState("");
  return (
    <div class="col-12 rtlMenu">
      <div class="row">
        <div class="col-lg-2 mymenu  ">
          <div class="col-lg-12 " style={{ textAlign: "center" }}>
            <Mylogo class="logoSize" src={Raeenlogo} alt="Raeen" />
            <h4 class="panelname">پنل مدیریت </h4>
          </div>
          <div class=" d-flex-column justify-content-start align-items-start ">
            <ul class="  " style={{ padding: "0" }}>
              <div>
                {" "}
                <li class="row listmenu ">
                  <img src="" class="" />

                  <FcManager class="icon" />
                  <Link to="/main/user" className="headMenuText">
                    شهرک ها
                  </Link>
                </li>
              </div>
              <div>
                {" "}
                <li class="row listmenu">
                  <FcNews class="icon" />
                  <Link to="/main/article" className="headMenuText">
                    اطلاعیه ها{" "}
                  </Link>
                </li>
              </div>

              <div>
                {" "}
                <li class="row listmenu">
                  <FcFlowChart class="icon" />
                  <Link to="/main/adscat" className="headMenuText">
                    دسته بندی آگهی ها
                  </Link>
                </li>
              </div>
              <div>
                {" "}
                <li class="row listmenu">
                  <FcList class="icon" />
                  <Link to="/main/ads" className="headMenuText">
                    آگهی ها
                  </Link>
                </li>
              </div>
              <div>
                {" "}
                <li class="row listmenu">
                  <FcGlobe class="icon" />
                  <Link to="/main/province" className="headMenuText">
                    استان
                  </Link>
                </li>
              </div>
              <div>
                {" "}
                <li class="row listmenu">
                  <FcBusinessman class="icon" />
                  <Link to="/main/All_user" className="headMenuText">
                    کاربران
                  </Link>
                </li>
              </div>
              <div>
                {" "}
                <li class="row listmenu">
                  <FcSupport class="icon" />
                  <Link to="/main/setting" className="headMenuText">
                    تنظیمات
                  </Link>
                </li>
              </div>
            </ul>

            <hr />
          </div>
        </div>

        <div class="col-lg-10 ">
          <div class="row headMenu">
            <div class="headMenuText">
              <button
                style={{ backgroundColor: "#D52B27", border: "none" }}
                className="btn btn-primary ml-4"
                onClick={() => history.push("/login")}
              >
                خروج
              </button>

              {/* {setrender(!render)} */}
            </div>
          </div>
          <div class="col-12 mydata">
            {/* <Route path='/main/user/:id' component={EditUser} /> */}

            {/* <Route path='/main/usertype/:id' component={AddUserType} /> */}

            <Route path="/main/user">
              <User_list />
            </Route>

            <Route path="/main/All_user">
              <All_User_list />
            </Route>
            <Route path="/main/indusUnit/:id" component={Indust} />

            <Route path="/main/article">
              <PostList />
            </Route>
            <Route path="/main/province">
              <Province />
            </Route>
            <Route path="/main/ads">
              <Ads />
            </Route>
            <Route path="/main/adscat">
              <AdsCat />
            </Route>
            <Route path="/main/setting">
              <Setting />
            </Route>

            {/* <Route path='/main/setting/:id' component={AddSetting} /> */}
          </div>
        </div>
      </div>
    </div>
  );
}
